module.exports = __webpack_public_path__ + "img/bulb_blue.7bf43a9d.svg";